/**
 * @generated SignedSource<<500d3774a17b14c6767cc80621a4546c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary" | "WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary">;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary"
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "e25fb00028cb50a166b64ae3df558672";

export default node;
